import { createStyles } from "antd-style";

export const useHeaderSystemViewStyles = createStyles(({ css }: any) => ({
  systemView: css``,
}));
